/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react'
import { SliderGroup } from './SliderGroup'
import { UseFormGetValues, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { motion } from 'framer-motion'
import TitleAni from './TitleAni'

type ListSearchProps = {
  dataCategoriesByCompany?: TChildrenCategories[]
  dataCategoriesByType?: TChildrenCategories[]
  dataCategoriesByEnd?: TChildrenCategories[]
  setValue: UseFormSetValue<BoxSearchForm>
  getValues: UseFormGetValues<BoxSearchForm>
  watch: UseFormWatch<BoxSearchForm>
  defaultFilter?: TDefaultWebsiteFilter
  onSubmit: Function
}
export const ListSearch = (props: ListSearchProps) => {
  const {
    dataCategoriesByCompany,
    dataCategoriesByType,
    dataCategoriesByEnd,
    setValue,
    getValues,
    watch,
    onSubmit,
  } = props

  return (
    <motion.div
      className="list-search"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="title-search">
        <div className="icon-brand">
          <img src="/image/ic-brand.svg" alt="" />
        </div>
        <div className="content-text">
          <TitleAni title="Tìm kiếm nhanh"></TitleAni>
        </div>
      </div>
      <div className="inner-content">
        <div className="progress">
          <div
            className={`progress-item  ${!!watch('company') ? 'is-done' : ''}`}
            onClick={() => {
              setValue('type', null)
              setValue('end', null)
            }}
          >
            <div className="progress-text">Lựa chọn</div>
            <div className="progress-title">Hãng xe</div>
          </div>
          <div
            className={`progress-item ${!!watch('company') ? 'current' : ''} ${
              !!watch('type') ? 'is-done' : ''
            }`}
            onClick={() => {
              setValue('type', null)
              setValue('end', null)
            }}
          >
            <div className="progress-text">Lựa chọn</div>
            <div className="progress-title">Dòng xe</div>
          </div>
          <div
            className={`progress-item ${!!watch('type') ? 'current' : ''} ${
              !!watch('end') ? 'is-done' : ''
            }`}
            onClick={() => {
              setValue('end', null)
            }}
          >
            <div className="progress-text ">Lựa chọn</div>
            <div className="progress-title">Đời xe</div>
          </div>
        </div>
        <div className="search-content">
          <SliderGroup
            dataCategoriesByCompany={dataCategoriesByCompany}
            dataCategoriesByType={dataCategoriesByType}
            dataCategoriesByEnd={dataCategoriesByEnd}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            onSubmit={onSubmit}
          />
        </div>
      </div>
    </motion.div>
  )
}
